import React from 'react';

import { MinimalAccountOrders } from './minimal-account-orders';

export const AccountOrders = () => <MinimalAccountOrders />;
